import styled, { css } from 'styled-components';
import get from 'lodash/get';
import shareUrl from '~/helpers/shareUrl';
import isClient from '~/helpers/isClient';
import Icon from '../../atoms/Icon';
import Container from '~/grid/Container';
import { mq } from '~/styles/grid';

const ContainerStyled = styled(Container)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.flexDirection &&
    css`
      flex-direction: ${props.flexDirection};
      align-items: flex-start;
    `};

  @media (${mq.xs}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ChannelsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Description = styled.div`
  color: ${(props) => props.theme.color.basicHeadlineColor};
  margin: 10px 25px 0 0;

  @media (${mq.xs}) {
    margin: 0 0 15px 0;
  }
`;

const Channel = styled.button`
  cursor: pointer;
  height: 40px;
  width: 40px;
  background-color: ${(props) => props.theme.color.gray50};
  color: ${(props) => props.theme.color.primary800};
  transition: background-color 0.25s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 15px 0 0;

  &:hover {
    background-color: ${(props) => props.theme.color.gray500};
  }

  &:last-of-type {
    margin-right: 0;
  }

  svg {
    max-width: 21px;
    max-height: 21px;
    width: 100%;
    height: 100%;
  }
`;

const StyledIcon = styled(Icon)`
  path {
    fill: ${(props) => props.theme.color.basicHeadlineColor};
  }
`;

/**
 * @param {ShareBtnsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const ShareBtns = ({
  label,
  flexDirection,
  channels = ['LINKEDIN', 'XING', 'TWITTER', 'FACEBOOK', 'WHATSAPP', 'MAIL'],
}) => {
  const url = isClient() ? get(window, 'location.href', null) : '';
  return (
    <ContainerStyled flexDirection={flexDirection}>
      <Description>{label}</Description>
      <ChannelsWrapper>
        {channels.map((channel, idx) => {
          return (
            <Channel
              key={idx}
              title={channel}
              onClick={() => shareUrl(channel, url)}
            >
              <StyledIcon icon={channel} />
            </Channel>
          );
        })}
      </ChannelsWrapper>
    </ContainerStyled>
  );
};

export default ShareBtns;
